import { get, find } from 'lodash'

const getters = {
    authServerError: state => state.app.error,
    isAuthenticated: state => !!state.app.auth_token,
    authStatus: state => state.app.status,
    userRole: state => state.app.user_role,
    getBoards: state => state.boards.boards,
    collectives: state => state.boards.collectives,
    streams: state => state.streams,
    // lastSale: state => get(state.streams, ['streams', 'statistic', 'company', 'last_sale'], null),
    // lastSaleUuid: (state, getters) => toString(get(getters.lastSale, ['uuid'], '')),
    searchAgent: state => id => find(get(state.streams, ['streams', 'users'], []), {id})
};
export default getters
